"use client"

import {LoginForm} from "@/components/LoginModal";
import {isLoggedIn} from "@/store/auth.store";
import {selectTicketPageContinue} from "@/app/events/[id]/store/buy-tickets.store";
import {useEffect} from "react";

const RedirectToCheckout = () => {
    useEffect(() => {
        selectTicketPageContinue()
    }, [])
    return (
        <div className="flex flex-col gap-4">
            <div className="text-lg font-semibold text-stone-neutral-12">
                Loading...
            </div>
        </div>
    )
}

export const CheckoutLoginForm = () => {

    return (
        // TODO: Maybe we could skip this step 
        <div className="flex justify-center items-center">
            <div className="w-96 mt-10">
                {
                    isLoggedIn.value ? <>
                        <RedirectToCheckout/>
                        {/*<div className="flex flex-col gap-4">
                            <div className="text-lg font-semibold text-stone-neutral-12">
                                Almost there...
                            </div>
                            <div className="text-sm text-stone-neutral-11">
                                You're just a step away from securing your ticket to an amazing experience.
                            </div>
                            <Button
                                className="bg-navy-blue hover:bg-navy-blue/85"
                                onClick={() => selectTicketPageContinue()}
                            >
                                Continue to pay
                            </Button>
                        </div>*/}
                    </> : <LoginForm fromCheckout={true}/>
                }

            </div>
        </div>
    )

}